module.exports = __webpack_public_path__ + "static/media/residence.8c4893a4.svg";